import { SpecificSyncStatus } from 'app/modules/settings/domain/entity/SpecificSyncStatus';

export class SpecificSyncStatusList {

    private readonly _items: SpecificSyncStatus[];
    private readonly _totalRecords: number;

    public constructor(
        items: SpecificSyncStatus[],
        totalRecords: number,
    ) {
        this._items = items;
        this._totalRecords = totalRecords;
    }

    public get items(): SpecificSyncStatus[] {
        return this._items;
    }

    public get totalRecords(): number {
        return this._totalRecords;
    }

}
